import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {ContentStyled} from '../../styles/components/content.style';

export const Wrapper = ContentStyled.extend`
  width: ${props => props.theme.basicPage.width};
  color: ${props => props.theme.primaryColor};
  background: ${props => props.theme.basicPage.backgroundColor};
  margin-top: ${props => props.theme.basicPage.offsetTop};
  text-align: center;
  ${media.small`
    width: 100%;
    margin: 0;
  `};
`;

export const Info = styled.div`
  font-size: ${props => props.theme.basicPage.fontSize};
`;



// WEBPACK FOOTER //
// ./containers/NewsletterUnsubscribe/NewsletterUnsubscribe.style.js